import React from 'react'

import type {Toggle} from 'types/Toggle'

type Value = {
  isCachedPage: boolean
  presetExperiments?: Record<string, string>
  serverToggle?: Toggle
}

const defaultValue: Value = {
  isCachedPage: true // Caching is opt-out and not all apps define the context
}

export const ServerExperimentsContext = React.createContext<Value>(defaultValue)

/**
 * Context for server-side experiment toggles
 */
export const useServerExperimentContext = () =>
  React.useContext(ServerExperimentsContext) || defaultValue
